/* CHU'S CHOICE — Holo Effect
   Baseado no codigo exato do deeppocketmonster.com
   Cores: --color1 (verde-azulado teal) + --color2 (dourado)
*/
(function(){

var css = `
  :root {
    --chu-c1: #e6a817;
    --chu-c2: #c97d1a;
  }

  @keyframes holoCard {
    0%, 100% { transform: rotateX(0deg) rotateY(0deg); }
    5%, 8%   { transform: rotateX(6deg) rotateY(-20deg); }
    13%, 16% { transform: rotateX(-9deg) rotateY(32deg); }
    35%, 38% { transform: rotateX(12deg) rotateY(20deg); }
    55%      { transform: rotateX(-12deg) rotateY(-27deg); }
  }
  @keyframes holoGradient {
    0%, 100% { opacity:.5; background-position:50% 50%; filter:brightness(.5) contrast(1); }
    5%, 9%   { background-position:100% 100%; opacity:1; filter:brightness(.75) contrast(1.25); }
    13%, 17% { background-position:0% 0%; opacity:.88; }
    35%, 39% { background-position:100% 100%; opacity:1; filter:brightness(.5) contrast(1); }
    55%      { background-position:0% 0%; opacity:1; filter:brightness(.75) contrast(1.25); }
  }
  @keyframes holoSparkle {
    0%, 100% { opacity:.75; background-position:50% 50%; filter:brightness(1.2) contrast(1.25); }
    5%, 8%   { opacity:1; background-position:40% 40%; filter:brightness(.8) contrast(1.2); }
    13%, 16% { opacity:.5; background-position:50% 50%; filter:brightness(1.2) contrast(.8); }
    35%, 38% { opacity:1; background-position:60% 60%; filter:brightness(1) contrast(1); }
    55%      { opacity:.33; background-position:45% 45%; filter:brightness(1.2) contrast(1.25); }
  }

  .chu-card {
    position: relative;
    transform-style: preserve-3d;
    border-radius: 8px;
    overflow: hidden;
    touch-action: pan-y;
    box-shadow:
      -5px -5px 5px -5px var(--chu-c1),
      5px 5px 5px -5px var(--chu-c2),
      -7px -7px 10px -5px transparent,
      7px 7px 10px -5px transparent,
      0 0 5px rgba(255,255,255,0),
      0 55px 35px -20px rgba(0,0,0,.5);
    transition: box-shadow .3s ease, transform .1s ease;
  }

  .chu-card:hover {
    box-shadow:
      -20px -20px 30px -25px var(--chu-c1),
      20px 20px 30px -25px var(--chu-c2),
      -7px -7px 10px -5px var(--chu-c1),
      7px 7px 10px -5px var(--chu-c2),
      0 0 13px 4px rgba(255,255,255,.3),
      0 55px 35px -20px rgba(0,0,0,.5);
    transition: box-shadow .1s ease-out;
  }

  .chu-card::before {
    content: "";
    position: absolute;
    inset: 0;
    background-repeat: no-repeat;
    background-size: 300% 300%;
    background-position: 50% 50%;
    background-image: linear-gradient(
      115deg,
      transparent 0%,
      var(--chu-c1) 25%,
      transparent 47%,
      transparent 53%,
      var(--chu-c2) 75%,
      transparent 100%
    );
    opacity: .5;
    mix-blend-mode: color-dodge;
    filter: brightness(.5) contrast(1);
    z-index: 9998;
    pointer-events: none;
    transition: .33s;
  }

  .chu-card::after {
    content: "";
    position: absolute;
    inset: 0;
    background-repeat: no-repeat;
    background-image: linear-gradient(
      125deg,
      rgba(255,0,132,.25)   15%,
      rgba(252,164,0,.20)   30%,
      rgba(255,255,0,.15)   40%,
      rgba(0,255,138,.10)   60%,
      rgba(0,207,255,.20)   70%,
      rgba(204,76,250,.25)  85%
    );
    background-position: 50% 50%;
    background-size: 160%;
    background-blend-mode: overlay;
    mix-blend-mode: color-dodge;
    opacity: .5;
    filter: brightness(1) contrast(1);
    z-index: 9999;
    pointer-events: none;
    transition: .3s;
  }

  .chu-card:hover::before,
  .chu-card.chu-active::before {
    background-image: linear-gradient(
      110deg,
      transparent 25%,
      var(--chu-c1) 48%,
      var(--chu-c2) 52%,
      transparent 75%
    );
    background-size: 250% 250%;
    opacity: .88;
    filter: brightness(.66) contrast(1.33);
    transition: none;
  }

  .chu-card:hover::after,
  .chu-card.chu-active::after {
    opacity: 1;
    filter: brightness(1) contrast(1);
    transition: none;
  }

  .chu-card.chu-animated          { animation: holoCard     12s ease 0s 1 normal none; }
  .chu-card.chu-animated::before  { animation: holoGradient 12s ease 0s 1 normal none; }
  .chu-card.chu-animated::after   { animation: holoSparkle  12s ease 0s 1 normal none; }
`;

var styleEl = document.createElement('style');
styleEl.id = 'chu-holo-styles';
styleEl.textContent = css;
document.head.appendChild(styleEl);

var hoverStyle = document.getElementById('chu-hover-style');
if(!hoverStyle){
  hoverStyle = document.createElement('style');
  hoverStyle.id = 'chu-hover-style';
  document.head.appendChild(hoverStyle);
}

function handleMove(e){
  var pos = [0, 0];
  if(e.type === 'touchmove'){
    var rect = e.currentTarget.getBoundingClientRect();
    pos = [
      e.touches[0].clientX - rect.left,
      e.touches[0].clientY - rect.top
    ];
  } else {
    pos = [e.offsetX, e.offsetY];
  }

  var card = e.currentTarget;
  var h = card.offsetHeight;
  var w = card.offsetWidth;

  var px = Math.abs(Math.floor((100/w)*pos[0]) - 100);
  var py = Math.abs(Math.floor((100/h)*pos[1]) - 100);
  var pa = 50 - px + (50 - py);

  var lp       = 50 + (px-50)/1.5;
  var tp       = 50 + (py-50)/1.5;
  var px_spark = 50 + (px-50)/7;
  var py_spark = 50 + (py-50)/7;
  var p_opc    = 20 + Math.abs(pa)*1.5;
  var ty       = ((tp-50)/2)*-1;
  var tx       = ((lp-50)/1.5)*0.5;

  var gradPos  = lp+'% '+tp+'%';
  var sparkPos = px_spark+'% '+py_spark+'%';
  var opc      = (p_opc/100).toFixed(2);
  var transform= 'rotateX('+ty.toFixed(1)+'deg) rotateY('+tx.toFixed(1)+'deg)';

  document.querySelectorAll('.chu-card').forEach(function(c){
    c.classList.remove('chu-active','chu-animated');
  });

  card.style.transform = transform;
  hoverStyle.textContent =
    '.chu-card:hover::before { background-position: '+gradPos+'; }' +
    '.chu-card:hover::after  { background-position: '+sparkPos+'; opacity: '+opc+'; }';

  /* REMOVIDO: e.preventDefault() — isso é tudo que travava o scroll */
}

function handleEnd(e){
  var card = e.currentTarget;
  hoverStyle.textContent = '';
  card.style.transform = '';
  setTimeout(function(){
    card.classList.add('chu-animated');
  }, 2500);
}

function attach(card){
  if(card._chu) return;
  card._chu = true;
  card.classList.add('chu-card');

  if(getComputedStyle(card).position === 'static'){
    card.style.position = 'relative';
  }

  card.addEventListener('mousemove', handleMove);
  card.addEventListener('mouseout', handleEnd);

  /* passive: true — scroll nunca bloqueado, tudo mais igual */
  card.addEventListener('touchmove',   handleMove, {passive: true});
  card.addEventListener('touchend',    handleEnd,  {passive: true});
  card.addEventListener('touchcancel', handleEnd,  {passive: true});

  setTimeout(function(){
    card.classList.add('chu-animated');
  }, 500 + Math.random()*2000);
}

function init(){
  var cards = document.querySelectorAll('product-card');
  cards.forEach(attach);
  if(!cards.length){
    document.querySelectorAll('li').forEach(function(li){
      if(li.querySelector('a[href*="/products/"]') && li.querySelector('img') && !li._chu){
        attach(li);
      }
    });
  }
}

if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

new MutationObserver(function(ms){
  if(ms.some(function(m){ return m.addedNodes.length > 0; })) init();
}).observe(document.body, {childList:true, subtree:true});

})();